import React from 'react';
import {Button, Paper, makeStyles} from '@material-ui/core';
import Modal from 'components/common/Modal';
import {useListFacilities} from 'hooks/lists';
import {fetchActiveImageSetVersions, deleteActiveImageSetVersion} from 'api/images';
import ActiveImageSetVersionForm from './ActiveImageSetVersionForm';
import ActiveImageSetVersionTable from './ActiveImageSetVersionTable';

const useStyles = makeStyles({
  information: {
    padding: 20,
  },
});

const ActiveImageSetVersionList = () => {
  const type = 'reading-reactions';
  const classes = useStyles();
  const {
    tableState,
    refreshTable,
    selectPage,
    selectItemsPerPage,
    changeFilter,
    changeSorter,
    changeExtraFilters,
    modalOpen,
    currentRecord,
    openModal,
    closeModal,
    triggerSoftRefresh,
    deleteRecord,
  } = useListFacilities({
    fetchRecords: fetchActiveImageSetVersions,
    deleteFn: deleteActiveImageSetVersion,
    deletionSuccessMsg: 'The active image set version has been successfully deleted!',
  });

  return (
    <div>
      <Modal
        title={currentRecord ? 'Update Active Image Set Version' : 'Create Active Image Set Version'}
        onClose={closeModal}
        open={modalOpen}
        maxWidth="sm"
        renderContent={() => (
          <ActiveImageSetVersionForm
            initialValues={currentRecord}
            onCancel={closeModal}
            onSubmitSuccess={triggerSoftRefresh}
            type={type}
          />
        )}
      />
      <div className="container content-box">
        <Paper className={classes.information}>
          <h3 className="section-header">
            <div className="section-title">Active Image Set Version List</div>
            <Button variant="contained" color="primary" className="pull-right" onClick={() => openModal()}>
              Create Active Image Set Version
            </Button>
          </h3>
          <ActiveImageSetVersionTable
            {...{
              tableState,
              refreshTable,
              selectPage,
              selectItemsPerPage,
              changeFilter,
              changeSorter,
              changeExtraFilters,
              showUpdateModal: openModal,
              onDeleteActionClick: deleteRecord,
            }}
          />
        </Paper>
      </div>
    </div>
  );
};

export default ActiveImageSetVersionList;
